import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Table,
  Select,
  Checkbox,
  Message,
  Icon
} from '@alifd/next';
import styles from './index.module.scss';

const { Item } = Form;

const ElevatorServiceList = (props) => {
  
 const data = [
   {
     id:1,
     name:"A1電梯",
     floor:"5樓",
     status: "上升",
   },
   {
     id:2,
     name:"A2電梯",
     floor:"2樓",
     status: "停止",
   },
 ]
  return (
    <>
    <div  className={styles.btnBox}>
    <h2>叫梯服務</h2>
    <button className={styles.btn}><Icon className={styles.icon} type="arrow-up" /></button>
    <button className={styles.btn}><Icon className={styles.icon} type="arrow-down" /></button>
    </div>
    <br />    <br />    
     <div className={styles.dataBoxTop}>
     <h2>電梯編號</h2>
       <h2>目前樓層</h2>
       <h2>進行狀態</h2>
       {/* <h2>操作</h2> */}
     </div>
     {data.map((list,index)=>{
       return(
        <div key={index} className={styles.dataBox}>
   
       <div className={styles.dataImgBox}><span><img  className={styles.img} src="https://i.ibb.co/3zgRH61/elevator.png" alt="img"></img></span><h2>{list.name}</h2></div>
       <h2 className={styles.floor}>{list.floor}</h2>
       <h2 className={list.status === "上升"?styles.statusColorUp:styles.statusColorDown}>{list.status}</h2>
       {/* <Button type="primary">呼叫</Button> */}
       </div>
       )
      
     })}
    </>
  );
};

export default ElevatorServiceList;
